import React, { createContext, useContext, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './AppLayout.css';

const AppLayoutContext = createContext(null);

export const useAppLayout = () => {
  const ctx = useContext(AppLayoutContext);
  if (!ctx) throw new Error('useAppLayout must be used within AppLayout');
  return ctx;
};

const NAV_ITEMS = [
  { path: 'calendar', icon: '📅', label: 'Ημερολόγιο', roles: [] },           // όλοι
  { path: 'bookings', icon: '📋', label: 'Κρατήσεις',  roles: ['salon-bookings', 'salon-clients'] },
  { path: 'clients',  icon: '👥', label: 'Πελάτες',    roles: ['salon-clients'] },
  { path: 'services', icon: '✂️', label: 'Υπηρεσίες',  roles: [], adminOnly: true },
  { path: 'stats',    icon: '📊', label: 'Στατιστικά', roles: [], adminOnly: true },
  { path: 'users',    icon: '👤', label: 'Χρήστες',    roles: [], adminOnly: true },
  { path: 'settings', icon: '⚙️', label: 'Ρυθμίσεις',  roles: [], adminOnly: true },
];

export default function AppLayout() {
  const { user, logout }  = useAuth();
  const navigate          = useNavigate();
  const location          = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openSidebar  = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);

  const handleNavClick = (path) => {
    navigate(`/app/${path}`);
    closeSidebar();
  };

  const activePath = location.pathname.replace('/app/', '').replace('/app', '') || 'calendar';
  const userRoles  = user?.roles || [];

  // Φιλτράρει nav items βάσει role
  const visibleNav = NAV_ITEMS.filter(item => {
    if (item.adminOnly) return user?.isAdmin;
    if (item.roles.length === 0) return true;  // calendar — όλοι
    return user?.isAdmin || item.roles.some(r => userRoles.includes(r));
  });

  return (
    <AppLayoutContext.Provider value={{ sidebarOpen, openSidebar, closeSidebar }}>
      <div className="app-layout">

        {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}

        <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
          <div className="sidebar-logo">
            <div className="logo-icon">✂</div>
            <div>
              <div className="logo-title">SalonBook</div>
              <div className="logo-sub">v1.0</div>
            </div>
            <button className="sidebar-close-btn" onClick={closeSidebar}>✕</button>
          </div>

          <div className="salon-info">
            <div className="salon-name">{user?.name || 'Κομμωτήριο'}</div>
            <div className="salon-status">
              <span className="dot" />
              {user?.isAdmin ? 'Διαχειριστής' : 'Υπάλληλος'}
            </div>
          </div>

          <nav className="sidebar-nav">
            <div className="nav-section">Κύριο μενού</div>
            {visibleNav.map(item => (
              <div
                key={item.path}
                className={`nav-item ${activePath === item.path ? 'active' : ''}`}
                onClick={() => handleNavClick(item.path)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </div>
            ))}
          </nav>

          <div className="sidebar-footer">
            <div className="user-avatar">
              {(user?.name || 'Α').charAt(0).toUpperCase()}
            </div>
            <div className="user-info">
              <div className="user-name">{user?.name || 'Χρήστης'}</div>
              <div className="user-email">{user?.email}</div>
            </div>
            <button className="logout-btn" onClick={logout}>⎋</button>
          </div>
        </aside>

        <main className="main-area">
          <Outlet />
        </main>

      </div>
    </AppLayoutContext.Provider>
  );
}